//src/reducers/index.js

import { combineReducers } from "redux";
import authen from "./authenReducer";
import apiCallsInProgress from "./apiStatusReducer";

// ── emis_pathology (original) reducers ──────────────────────────────────────
import activityFrameReducer from "./activityFrameSlice.js";
import dashboardFrameSlice from "./dashboardFrameSlice.js";
import dashFrameSlice from "./dashFrameSlice.js";
import patientFrameSlice from "./patientFrameSlice.js";
import fullPatientFrameSlice from "./fullPatientFrameSlice.js";
import skipAnalysisSlice from "./skipAnalysisSlice.js";
import fullSkipAnalysisSlice from "./fullSkipAnalysisSlice.js";
import reviewFrameSlice from "./reviewFrameSlice.js";
import filingRulesSlice from "./filingRulesSlice.js";
import ruleFrameSlice from "./ruleFrameSlice.js";
import bloodTestsSlice from "./bloodTestSlice.js";
import rulesetSlice from "./rulesetSlice.js";
import credentialsSlice from "./credentialsSlice.js";
import settingsSlice from "./settingsSlice.js";
import rulesInReviewSlice from "./rulesInReviewSlice";
import categoryGroupsSlice from "./categoryGroupsSlice";
import secondaryAccountSlice from "./secondaryAccountSlice.js";

// ── s1_pathology reducers (separate API namespace) ──────────────────────────
import s1ActivityFrameReducer from "../s1_pathology/reducers/activityFrameSlice.js";
import s1DashFrameReducer from "../s1_pathology/reducers/dashFrameSlice.js";
import s1DashboardFrameReducer from "../s1_pathology/reducers/dashboardFrameSlice.js";
import s1FilingRulesReducer from "../s1_pathology/reducers/filingRulesSlice.js";
import s1PatientFrameReducer from "../s1_pathology/reducers/patientFrameSlice.js";
import s1ReviewFrameReducer from "../s1_pathology/reducers/reviewFrameSlice.js";
import s1SkipAnalysisReducer from "../s1_pathology/reducers/skipAnalysisSlice.js";
import s1RuleFrameReducer from "../s1_pathology/reducers/ruleFrameSlice.js";
import s1RulesetReducer from "../s1_pathology/reducers/rulesetSlice.js";
import s1SettingsReducer from "../s1_pathology/reducers/settingsSlice.js";
import s1CredentialsReducer from "../s1_pathology/reducers/credentialsSlice.js";

const appReducer = combineReducers({
  authen,

  // emis_pathology state keys
  activityFrame: activityFrameReducer,
  rulesInReview: rulesInReviewSlice,
  dashboardFrame: dashboardFrameSlice,
  categoryGroups: categoryGroupsSlice,
  skipAnalysis: skipAnalysisSlice,
  fullSkipAnalysis: fullSkipAnalysisSlice,
  dashFrame: dashFrameSlice,
  pathologySearch: patientFrameSlice,
  fullPathologySearch: fullPatientFrameSlice,
  reviewFrame: reviewFrameSlice,
  filingRules: filingRulesSlice,
  ruleFrame: ruleFrameSlice,
  bloodTests: bloodTestsSlice,
  ruleset: rulesetSlice,
  credentials: credentialsSlice,
  settings: settingsSlice,
  secondaryAccount: secondaryAccountSlice,

  // s1_pathology state keys (prefixed with s1 to avoid collisions)
  s1ActivityFrame: s1ActivityFrameReducer,
  s1DashFrame: s1DashFrameReducer,
  s1DashboardFrame: s1DashboardFrameReducer,
  s1FilingRules: s1FilingRulesReducer,
  s1PathologySearch: s1PatientFrameReducer,
  s1ReviewFrame: s1ReviewFrameReducer,
  s1SkipAnalysis: s1SkipAnalysisReducer,
  s1RuleFrame: s1RuleFrameReducer,
  s1Ruleset: s1RulesetReducer,
  s1Settings: s1SettingsReducer,
  s1Credentials: s1CredentialsReducer,

  apiCallsInProgress,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
